/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payload_Not_ArchivedInputs */

const en_error_payload_not_archived = /** @type {(inputs: Error_Payload_Not_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The body of this message is not in the archive: it could not be stored, or it is no longer kept.`)
};

/**
* | output |
* | --- |
* | "The body of this message is not in the archive: it could not be stored, or it is no longer kept." |
*
* @param {Error_Payload_Not_ArchivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_payload_not_archived = /** @type {((inputs?: Error_Payload_Not_ArchivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payload_Not_ArchivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_payload_not_archived(inputs)
});